import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { ErrorComponent } from "./shared/components/error/error.component";

const routes: Routes = [
  {
    path: "home",
    loadChildren: "./modules/home/home.module#HomeModule",
  },
  {
    path: "register",
    loadChildren: "./modules/register/register.module#RegisterModule",
  },
  {
    path: "modify",
    loadChildren: "./modules/modify/modify.module#ModifyModule",
  },
  { path: "", redirectTo: "home", pathMatch: "full" },
  { path: "**", component: ErrorComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
